// Minutes since local midnight for an "HH:mm" or "HH:mm:ss" wall-clock string; seconds are ignored.
export const minuteOfDay = (time: string): number => {
	const [hour = 0, minute = 0] = time.split(":").map(Number);
	return hour * 60 + minute;
};
